import React from 'react';
import { PropTypes } from 'prop-types';
import SelectList from 'components/FormInputs/SelectList';
import states from 'i18n/us-states';
import { withTranslation } from 'react-i18next';

const StateSelect = withTranslation()(props => (
  <div>
    <SelectList
      name={props.name}
      label={props.t(['addressForm.state', 'State'])}
      prompt={props.t(['addressForm.selectAState', 'Select a State'])}
      data={props.states || states}
      valueField="isoCode"
      textField="name"
      {...props}
    />
  </div>
));

StateSelect.propTypes = {
  name: PropTypes.string,
};

StateSelect.defaultProps = {
  name: undefined,
};

export default StateSelect;
